import styled from "styled-components";
import { STYLED_CONSTANTS } from "./constant";

export const HeadingTitleContainer = styled.div(({ theme }) => ({
    textAlign: "center" as const,
    marginTop: theme.spacing.xSmall,
}));

export const DescriptionContainer = styled.div(({ theme }) => ({
    textAlign: "center" as const,
    marginTop: theme.spacing.xSmall,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    paddingTop: theme.spacing.medium,
    paddingLeft: STYLED_CONSTANTS.MARGIN_LEFT,
    paddingRight: STYLED_CONSTANTS.MARGIN_RIGHT,
    paddingBottom: `calc(var(--sab, 0px) + ${STYLED_CONSTANTS.MARGIN_BOTTOM})`,
    background: theme.colors[theme.colorMode].canvas_Primary,
}));
